var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useEffect, createContext, useState, useMemo } from 'react';
import SettingRouters from './setting/routers';
import { getAllDoc } from '@src/utils/api/doc';
import { useDispatch, useSelector } from 'react-redux';
import useLocale from '@src/hooks/useLocale';
export var RouterContext = /*#__PURE__*/createContext({
  refresh: function refresh() {
    return undefined;
  }
});
export default function useMenus(themeId) {
  var _this = this;
  var _a = __read(useState(false), 2),
    ready = _a[0],
    setReady = _a[1];
  var _b = __read(useState(false), 2),
    loading = _b[0],
    setLoading = _b[1];
  var docs = useSelector(function (state) {
    return state.theme.docs;
  });
  var dispatch = useDispatch();
  var isDefaultLang = useLocale().isDefaultLang;
  var menus = useMemo(function () {
    var routers = {};
    var loop = function loop(items) {
      return items.map(function (item) {
        var _a;
        if (item.items) {
          loop(item.items);
        } else {
          item.name = ((_a = docs[item.key]) === null || _a === void 0 ? void 0 : _a[isDefaultLang ? 'title' : 'enTitle']) || item.name;
        }
      });
    };
    for (var key in SettingRouters) {
      loop(SettingRouters[key].items || []);
      routers["setting/" + key] = SettingRouters[key];
    }
    return routers;
  }, [docs, isDefaultLang]);
  var reloadData = function reloadData() {
    return __awaiter(_this, void 0, void 0, function () {
      var _a, docs;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            setLoading(false);
            return [4, Promise.all([getAllDoc({
              themeId: themeId
            })])];
          case 1:
            _a = __read.apply(void 0, [_b.sent(), 1]), docs = _a[0];
            dispatch({
              type: 'setDocs',
              payload: docs
            });
            setLoading(true);
            return [2];
        }
      });
    });
  };
  useEffect(function () {
    reloadData().then(function () {
      setReady(true);
    });
  }, [themeId]);
  return {
    refresh: function refresh() {
      reloadData();
    },
    docs: docs,
    routers: menus,
    ready: ready,
    loading: loading
  };
}